import { Input } from 'antd'
import React from 'react'
import { TextAreaProps } from 'antd/es/input'
import { IconPaperAirplane } from '../../../icons/IconPaperAirplane'
import { IconButton } from '../../../buttons/icon-button/IconButton'

const { TextArea } = Input

export const AiChatInput = (props: TextAreaProps) => {
  return (
    <div className={'flex items-end rounded-[6px] shadow-outline p-[8px] shadow-focus/[0.65]'}>
      <div className='p-[4px] w-full'>
        <TextArea
          {...props}
          className={'p-0 text-[15px] scrollbar-hide !border-none !outline-none focus:shadow-none'}
        />
      </div>
      <div className={props.value ? 'visible' : 'hidden'}>
        <IconButton className={'bg-[#A059FF]'} size={'lg'} type={'submit'}>
          <IconPaperAirplane />
        </IconButton>
      </div>
    </div>
  )
}
